import React, { Component } from 'react'

export default class Experiencie extends Component {
    render() {
        return (
            <div>
                <div className="w3-container w3-card w3-white w3-margin-bottom">
                    <h2 className="w3-text-grey w3-padding-16"><i className="fa fa-suitcase fa-fw w3-margin-right w3-xxlarge w3-text-dark-grey"></i>Experiencia Laboral</h2>
                    <div className="w3-container">
                        <h5 className="w3-opacity"><b>Backend / Calaverita.tech</b></h5>
                        <h6 className="w3-text-dark-grey"><i className="fa fa-calendar fa-fw w3-margin-right"></i>Marzo 2020 - <span className="w3-tag w3-dark-grey w3-round">Actual</span></h6>
                        <p>Implemente tecnologías del lado del servidor, desarrollado con Node, Express, Moongose (MongoDB), Sequelize (MySQL), JWT, Swagger (Documentación de la API).</p>
                        <hr/>
                    </div>
                    <div className="w3-container">
                        <h5 className="w3-opacity"><b>Desarrollo Móvil Híbrido / Doover Network</b></h5>
                        <h6 className="w3-text-dark-grey"><i className="fa fa-calendar fa-fw w3-margin-right"></i>Enero 2020 - Febrero 2020</h6>
                        <p>Participe en el desarrollo de una aplicación móvil con React Native, el cual llevo un compendio de librerías para generar QR, notificaciones con Firebase, Geo-posicionamiento, entre otras. Backend con Laravel y eventos Pusher.</p>
                        <hr/>
                    </div>
                    <div className="w3-container">
                        <h5 className="w3-opacity"><b>Desarrollo Full Stack / INSOPESCA</b></h5>
                        <h6 className="w3-text-dark-grey"><i className="fa fa-calendar fa-fw w3-margin-right"></i>Enero 2017 - Diciembre 2019</h6>
                        <p>Implemente un manual de buenas prácticas para el desarrollo del código del sistema RIPAC en el Framework Laravel de PHP, Migre el código del sistema de la versión 4.2 del Framework a la 5.5, Implemente Código QR, PDF, Análisis Estadísticos, Registro de Tramites Gubernamentales. Realice un sistema de Gestión de RRHH, entre otros. Base de Datos PostgreSQL. Implementación de un Servidor de Pruebas con Ubuntu Server y GitLab. </p><br/>
                        <hr/>
                    </div>
                    <div className="w3-container">
                        <h5 className="w3-opacity"><b>Desarrollo Full Stack / MPPPA</b></h5>
                        <h6 className="w3-text-dark-grey"><i className="fa fa-calendar fa-fw w3-margin-right"></i>Mayo 2016 - Diciembre 2016</h6>
                        <p>Desarrolle un Bloc de Tareas para el área de Desarrollo Tecnológico, Participe en el desarrollo del proyecto RIPAC en Laravel 4.2.</p><br/>
                        <hr/>
                    </div>
                </div>
            </div>
        )
    }
}
